import LawFirmHomeBase from "./components/LawFirmHomeBase";
import { LF_HOME_VARIANT } from "./lawFirmHomeConfig";

const LawFirmUserHome = () => <LawFirmHomeBase variant={LF_HOME_VARIANT.user} />;

export default LawFirmUserHome;
